module.exports = function(app) {
    app.directive('myOralHealthMessage', function() {

        return {
            restrict: 'A',
            replace: true,
            templateUrl: 'coverage.appTemplate.html/chmhom/directives/myOralHealthMessage',

            controller: ['$scope', 'aemContent', function($scope, aemContent) {
                $scope.showBenefits = false;

                aemContent.get('MBR_COVERAGE_ORAL_HEALTH_MESSAGE_4').then(function (data) {
                    $scope.contactInfoMsg = data;
                });
            }]
        };
    });
};